import { createSlice } from "@reduxjs/toolkit";
import { ISpeak } from "../types";

interface IResponseToolState {
  speakArray: ISpeak[];
  copiedText: string;
  isCopied: boolean;
}

const initialState: IResponseToolState = {
  speakArray: [],
  copiedText: "",
  isCopied: false,
};

const responseToolSlice = createSlice({
  name: "response-tools",
  initialState,
  reducers: {
    setSpeakArray(state, action) {
      state.speakArray = action.payload;
    },
    setCopiedText(state, action) {
      state.copiedText = action.payload;
    },
    setIsCopied(state, action) {
      state.isCopied = action.payload;
    },
  },
});

export const { setSpeakArray, setCopiedText, setIsCopied } =
  responseToolSlice.actions;
export default responseToolSlice.reducer;
